<template>
    <div class="regular_test">
        <div class="progress_list mar_top_10" v-if="progressList.length >= 0">
            <div class="list_top flex FlexBetween Flexalign">
                <div class="list_chapter toverflow">章节名称</div>
                <div class="list_name">题数</div>
                <div class="list_time">测试结果</div>
            </div>
            <div class="list_top flex FlexBetween Flexalign list_one" v-for="(item, index) in progressList" :key="index"
                :class="[index % 2 == 1 ? 'active_bg' : '']">
                <div class="list_chapter toverflow">{{ item.chapterName }}</div>
                <div class="list_name">{{ item.questionCount }}</div>
                <div class="list_time">{{ item.submitCount > 0 ? (item.maxScore + "/" + item.fullScore) : '未开始' }}</div>
            </div>
        </div>
        <div v-else>
            <moe-empty :url="'note_empty_bg_img.png'" emptyText="暂无测试记录"></moe-empty>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GjkcH5RegularTest',
    props: {
        courseDetail: {}
    },

    data() {
        return {
            progressList: []
        };
    },

    mounted() {
        this.getCourseTestList();
    },

    methods: {
        getCourseTestList() {
            this.$Api.exam.getCourseTestList(this.courseDetail.courseId).then(res => {
                this.progressList = res.data.data;
            }).catch(() => { })
        }
    },
};
</script>

<style lang="scss" scoped>
.regular_test {
    .progress_list {
        .list_top {
            text-align: center;
            color: #333333;
            // font-weight: 600;
            height: 45px;
            line-height: 45px;

            .list_chapter {
                width: 50%;
            }

            .list_name {
                width: 25%;
            }

            .list_time {
                width: 25%;
            }
        }

        .list_one {
            color: #999999;
        }

        .active_bg {
            background: #F8F9FA;
        }
    }
}
</style>